import React, { useState } from "react";
import search_icon from "../assets/icons/search_icon.png";

const ExhibitionUsersFilters = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };
  return (
    <div className="mt-4 border h-screen rounded-md p-2">
      <div className="text-[16px] text-[#828282]">FILTERS</div>
      <p className="text-[#828282] text-[12px] mt-3">Search contact person</p>
      <div className="flex border border-[#95C2FF] rounded-lg">
        <img
          src={search_icon}
          alt="search icon"
          className="w-5 object-contain mx-1"
        />
        <input
          type="text"
          placeholder="Search contact person here"
          className="text-[12px] w-full p-2 rounded-lg"
        />
      </div>
      <div className="mt-2">
        <div
          onClick={toggleAccordion}
          style={{ cursor: "pointer" }}
          className="flex items-center justify-between"
        >
          <p className="text-[12px] font-bold">Vendor</p>

          <div
            style={{
              transform: isOpen ? "rotate(180deg)" : "rotate(0)",
            }}
            className="text-[30px] pr-2"
          >
            &#8964; {/* Down arrowhead*/}
          </div>
        </div>

        {isOpen && (
          <div className="flex flex-col">
            <p className="text-[10px] mb-2">Users</p>
            <label className="flex mb-2">
              <input type="checkbox" />
              <p className="pl-2 text-[12px]">Praveen Sharma</p>
            </label>
            <label className="flex mb-2">
              <input type="checkbox" />
              <p className="pl-2 text-[12px]">Ananya Gupta</p>
            </label>
            <label className="flex mb-2">
              <input type="checkbox" />
              <p className="pl-2 text-[12px]">Praveen Sharma</p>
            </label>
            <label className="flex mb-2">
              <input type="checkbox" />
              <p className="pl-2 text-[12px]">Ananya Gupta</p>
            </label>
            <label className="flex mb-2">
              <input type="checkbox" />
              <p className="pl-2 text-[12px]">Praveen Sharma</p>
            </label>
            <label className="flex mb-2">
              <input type="checkbox" />
              <p className="pl-2 text-[12px]">Ananya Gupta</p>
            </label>
          </div>
        )}
      </div>

      <div
        style={{ cursor: "pointer" }}
        className="flex items-center justify-between"
      >
        <p className="text-[12px] font-bold">Manager</p>

        <div
          style={{
            transform: isOpen ? "rotate(180deg)" : "rotate(0)",
          }}
          className="text-[30px] pr-2"
        >
          &#8964; {/* Down arrowhead*/}
        </div>
      </div>
      <div
        style={{ cursor: "pointer" }}
        className="flex items-center justify-between"
      >
        <p className="text-[12px] font-bold">Retailer</p>

        <div
          style={{
            transform: isOpen ? "rotate(180deg)" : "rotate(0)",
          }}
          className="text-[30px] pr-2"
        >
          &#8964; {/* Down arrowhead*/}
        </div>
      </div>
      <div
        style={{ cursor: "pointer" }}
        className="flex items-center justify-between"
      >
        <p className="text-[12px] font-bold">Profession 1</p>

        <div
          style={{
            transform: isOpen ? "rotate(180deg)" : "rotate(0)",
          }}
          className="text-[30px] pr-2"
        >
          &#8964; {/* Down arrowhead*/}
        </div>
      </div>

      <div className="flex justify-between mt-2">
        <button className="p-2 text-[14px] font-bold text-[#2F80ED] border border-[#2F80ED] rounded-lg w-[49%]">
          Discard
        </button>
        <button className="p-2 text-[14px] font-bold bg-[#2F80ED] text-white rounded-lg w-[49%]">
          Apply
        </button>
      </div>
    </div>
  );
};

export default ExhibitionUsersFilters;
